/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is this different from a dilution calculator?`)
};

const es_massmol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿En qué se diferencia de una calculadora de dilución?`)
};

const de_massmol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie unterscheidet sich das von einem Verdünnungsrechner?`)
};

const nl_massmol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil met een verdunningscalculator?`)
};

const fr_massmol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En quoi est-ce différent d'un calculateur de dilution ?`)
};

const it_massmol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In cosa differisce da un calcolatore di diluizione?`)
};

const pt_br2_massmol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual a diferença em relação a uma calculadora de diluição?`)
};

const pt_massmol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que difere de uma calculadora de diluição?`)
};

const ja_massmol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`希釈計算ツールとの違いは何ですか？`)
};

const zh_massmol_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这与稀释计算器有什么不同？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_faq_q4", locale)
	if (locale === "en") return en_massmol_faq_q4(inputs)
	if (locale === "es") return es_massmol_faq_q4(inputs)
	if (locale === "de") return de_massmol_faq_q4(inputs)
	if (locale === "nl") return nl_massmol_faq_q4(inputs)
	if (locale === "fr") return fr_massmol_faq_q4(inputs)
	if (locale === "it") return it_massmol_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_faq_q4(inputs)
	if (locale === "pt") return pt_massmol_faq_q4(inputs)
	if (locale === "ja") return ja_massmol_faq_q4(inputs)
	return zh_massmol_faq_q4(inputs)
};